import {formatCurrency} from '../../../utils';

const CurrencyTotals = ({totals, fallback = '—'}) => {
    const entries = Object.entries(totals);
    if (entries.length === 0) return <span className="text-faint">{fallback}</span>;
    return entries.map(([currency, amount]) => (
        <span key={currency} className={`stat-value ${amount >= 0 ? 'positive-value' : 'negative-value'}`}>
            {formatCurrency(amount, currency)}
        </span>
    ));
};

export default CurrencyTotals;